import type { NavItem } from 'finara-components';

export const adminNavItems: NavItem[] = [
  { text: 'Dashboard General', url: '/dashboard-empresarial' },
  {
    title: 'Empleados',
    links: [
      { text: 'Gestión de Empleados', url: '/empleados/directorio' },
      { text: 'Onboarding', url: '/empleados/onboarding' },
    ],
  },
  {
    title: 'Operaciones',
    links: [
      { text: 'Centro de pagos', url: '/operaciones-empresariales/centro-de-pagos' },
      { text: 'Adelantos de Nómina', url: '/operaciones-empresariales/adelantos-de-nomina' },
    ],
  },
  {
    title: 'Reportes & Datos',
    links: [
      { text: 'Estados de Cuenta', url: '/reportes/estados-de-cuenta' },
      { text: 'Evaluación de Riesgos', url: '/reportes/evaluacion-de-riesgos' },
    ],
  },
  {
    title: 'Configuración',
    links: [
      { text: 'Usuarios y Roles', url: '/configuracion/usuarios-y-roles' },
      { text: 'Parámetros Empresariales', url: '/configuracion/parametros-empresariales' },
    ],
  },
];
